import React from 'react';

import { PhoneProviderContext } from '@app/providers/PhoneProvider/PhoneProvider';

const RestrictedLocation: React.FC = () => {
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>We’re sorry. Online booking is currently not available in your area.</p>
					<p>
						Please call our Support Center to help finalize your booking
						{' '}
						<span className="inline-block">
							<a href={contextPhone.state.phoneNumberHref} className="inline-link">
								{`${contextPhone.state.phoneNumberDisplay}.`}
							</a>
						</span>
					</p>
					<p>Thank you for your patience!</p>
				</div>
			</div>
		</div>
	);
};

export default RestrictedLocation;
